import { rankingList } from "@/mocks/manga";

export default function Ranking() {
  return (
    <section id="ranking" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-4 py-1.5 text-sm font-medium text-accent-600">
            <i className="ri-fire-line"></i>
            实时热榜
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            人气榜单
          </h2>
          <p className="mt-3 max-w-xl text-base text-foreground-700">
            万千读者用追更投票选出的奇幻佳作，每一部都值得一口气追完。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {rankingList.map((item) => (
            <article
              key={item.rank}
              className="group relative overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.name}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-lg font-heading text-lg font-bold text-background-50 ${
                    item.rank <= 3 ? "bg-accent-500" : "bg-background-600"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-background-950/70 px-2 py-0.5 text-xs text-primary-400 backdrop-blur">
                  {item.score}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-500">
                  {item.name}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600">
                  {item.category} · {item.chapter}
                </p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-fill text-accent-500"></i>
                    {item.fans}
                  </span>
                  <a
                    href="#latest"
                    className="text-primary-500 transition-colors hover:text-primary-400"
                  >
                    立即观看
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}